import { api } from '@/services/api';
import type { SignInErrorReport } from '@/api/api';

const MAX_MESSAGE_LENGTH = 1000;

export const reportSignInError = async (source: SignInErrorReport['source'], message: string): Promise<void> => {
  try {
    await api.signInErrors.report({ source, message: message.slice(0, MAX_MESSAGE_LENGTH) });
  } catch {
    // Reporting is best-effort: a failed report must never change what the user sees.
  }
};
